module.exports = __webpack_public_path__ + "static/media/06.112.3c35c515.webp";